/**
 * Modos con editor standalone en `/studio/:mode` (StudioModePage).
 * Cualquier otro modo generado por recetas debe envolverse en un EvaluationExam.
 */
export const STANDALONE_ACTIVITY_MODES = [
  'poll',
  'arena',
  'coop',
  'sandbox',
  'order',
  'point',
  'wall',
  'vincula',
] as const;

export type StandaloneActivityMode = (typeof STANDALONE_ACTIVITY_MODES)[number];

export function isStandaloneActivityMode(mode: string): mode is StandaloneActivityMode {
  return (STANDALONE_ACTIVITY_MODES as readonly string[]).includes(mode);
}
